import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const NotAllowedChannelLogoContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: ${Screen.widthRatio * 330}px;
  left: ${Screen.widthRatio * 880}px;
  height: ${149 * Screen.widthRatio}px;
  width: ${149 * Screen.widthRatio}px;
`;

export default NotAllowedChannelLogoContainer;
